import BulkImportStepper from '../3modules/DataBulkImport/BulkImportStepper'
import FileUploader from '../2compounds/FileUploader'
import React, { useState } from 'react'
import { FeedbackSnackbar, Text } from '../1elements'
import ConfirmationMessage from '../3modules/DataExport/ConfirmationMessage'
import LoaderBackdrop from '../2compounds/LoaderBackdrop'
import BulkImportErrorModal from '../3modules/DataBulkImport/BulkImportErrorModal'

const DataBulkImportTabTemplate = ({ dataType, handleImportApi, downloadTemplate, setTemplate, formatPath, templateHeaderList }) => {
  const stepHeadings = [`Download ${dataType} Template`, 'Check Rules', 'Upload CSV File', 'Import Data']

  const [selectedFileName, setSelectedFileName] = useState('')
  const [dataArrayFromCsv, setDataArrayFromCsv] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [snackbar, setSnackbar] = useState({
    severity: 'success',
    message: 'Your data is successfully imported.',
    isOpen: false
  })
  const [errorModalOpen, setErrorModalOpen] = useState(false)
  const [errorMessagesList, setErrorMessagesList] = useState([])

  const openSnackbar = () => {
    setSnackbar({ ...snackbar, isOpen: true })
  }

  const handleDownloadTemplateButton = async () => {
    try {
      await downloadTemplate()
    } catch {
      setSnackbar({
        severity: 'fail',
        message: 'Something went wrong. Please download template again.',
        isOpen: true
      })
    }
  }
  const handleSetTemplate = async () => {
    try {
      await setTemplate()
    } catch {
      setSnackbar({
        severity: 'fail',
        message: 'Something went wrong. Please download template again.',
        isOpen: true
      })
    }
  }

  const handleImportButton = async () => {
    try {
      setIsLoading(true)
      await handleImportApi(dataArrayFromCsv)
      setIsLoading(false)
      openSnackbar()
    } catch (e) {
      setIsLoading(false)

      if (e.response.statusText === 'Payload Too Large') {
        setErrorMessagesList(`${e.response.statusText}.Please, insert 40 rows or less`)
      } else {
        // The API added validation, the old implementation this call displays
        // a generic message (400 bad request), the following if statement at least
        // tells the user what is wrong with CSV that is being uploaded

        if (e.response.data && e.response.data.length && e.response.data[0]) {
          setErrorMessagesList(e.response.data[0])
        } else {
          setErrorMessagesList(e.response.statusText)
        }
      }

      setErrorModalOpen(true)
    }
  }

  const DownloadTemplateStep = (
    <Text>Download the latest template file by clicking the button below.</Text>
  )

  const CheckRuleStep = (
    <Text type='learnFormatHelper'>
      <a href={formatPath} rel='noopener noreferrer' target='_blank'>Learn
      </a> about the required fields and format to enter the data.
    </Text>
  )

  const FileUploadStep = (
    <>
      <Text>Select the template file that you filled out</Text>
      <FileUploader
        maxFiles={1} setDataArrayFromCsv={setDataArrayFromCsv}
        selectedFileName={selectedFileName} setSelectedFileName={setSelectedFileName}
        templateHeaderList={templateHeaderList}
        accept={'.csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, ' +
                              'application/x-csv, text/comma-separated-values, text/x-comma-separated-values'}
      />
    </>
  )

  const selectedValuesObject = {
    'Selected CSV File': dataArrayFromCsv.length ? selectedFileName : ''
  }
  const Confirmation = (<ConfirmationMessage selectedValuesObject={selectedValuesObject} />)

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return DownloadTemplateStep
      case 1:
        return CheckRuleStep
      case 2:
        return FileUploadStep
      case 3:
        return Confirmation
      default:
        return 'Unknown step'
    }
  }

  const disabled = (step) => {
    switch (step) {
      case 0:
        return false
      case 1:
        return false
      case 2:
        return !dataArrayFromCsv.length
      default:
        return false
    }
  }

  return (
    <div>
      <BulkImportStepper
        stepHeadings={stepHeadings} handleImportButton={handleImportButton}
        getStepContent={getStepContent} disabled={disabled} customFirstButton={handleDownloadTemplateButton} setTemplate={handleSetTemplate}
      />
      <LoaderBackdrop open={isLoading} />
      <FeedbackSnackbar snackbar={snackbar} setSnackbar={setSnackbar} />
      <BulkImportErrorModal open={errorModalOpen} setOpen={setErrorModalOpen} errorMessagesList={errorMessagesList} />
    </div>
  )
}

export default DataBulkImportTabTemplate
